import { render } from "./category-detail.vue?vue&type=template&id=d23ff5d2&scoped=true"
import script from "./category-detail.vue?vue&type=script&lang=js"
export * from "./category-detail.vue?vue&type=script&lang=js"

import "./category-detail.vue?vue&type=style&index=0&id=d23ff5d2&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d23ff5d2"]])

export default __exports__